var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-skeleton',{attrs:{"animated":""}},[_c('template',{slot:"template"},[_c('el-skeleton-item',{staticStyle:{"width":"100%","height":"50px"},attrs:{"variant":"image"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }